import React from 'react';
import {
    i18n,
    Login,
    SignUp,
    ForgotPassword,
    HomeInviteSignupScreen,
    GuardianConsentScreen,
    CreateEliteAccount,
    WelcomeMobileWeb,
    InvitationCodeSignup,
    CreatePreAccount,
    PreAccountSetPasswordScreen,
    CaptureEmailScreen,
    PreLoadedPlanDetails,
} from 'fitbeat.react-native-components';
import { createSwitchNavigator } from 'react-navigation';
import { BaseAuthLayout } from '../Components/Layouts/BaseAuthLayout';
import { HomeCarouselAuthLayout } from '../Components/Layouts/HomeCarouselAuthLayout';
import { SocialAuthLoading } from '../Components/SocialAuthLoading';
import { PreLoadedPlanDetailsContainer } from '../Components/PreLoadedPlanDetailsContainer';
import { ExternalPlanSelectionContainer } from '../Components/ExternalPlanSelectionContainer';
import { HomeInstallAppContainer } from '../Components/HomeInstallAppContainer';

const isMobile = window.innerWidth <= 550;

const LoginContainer = (props) => {
    return (
        <HomeCarouselAuthLayout header={"Login"} hasAccessToAStudioGym={false} {...props}>
            <Login {...props} />
        </HomeCarouselAuthLayout>
    )
}

export const SignupContainer = (props) => {
    return (
        <HomeCarouselAuthLayout {...props} hasAccessToAStudioGym={true}>
            <SignUp {...props} />
        </HomeCarouselAuthLayout>
    )
}

const ForgotPasswordContainer = (props) => {
    return (
        <HomeCarouselAuthLayout header={"Forgot Password"} hasAccessToAStudioGym={false} {...props}>
            <ForgotPassword {...props} />
        </HomeCarouselAuthLayout>
    )
}

export const GuardianConsentScreenContainer = (props) => {
    return (
        <HomeCarouselAuthLayout header={i18n.t("auth:guardianInformation")} hasAccessToAStudioGym={true} {...props}>
            <GuardianConsentScreen {...props} />
        </HomeCarouselAuthLayout>
    )
}

const CreateEliteAccountContainer = (props) => {
  return (
    <HomeCarouselAuthLayout {...props} hasAccessToAStudioGym={false}>
      <CreateEliteAccount {...props} />
    </HomeCarouselAuthLayout>
  )
}

const InviteToWorkoutContainer = (props) => {
    return (
        <HomeCarouselAuthLayout hasAccessToAStudioGym={false} {...props} hideScroll>
            <div className={'full-height hide-scroll-bar'} id="right-content">
                <HomeInviteSignupScreen {...props} />
            </div>
        </HomeCarouselAuthLayout>
    )
}

const InvitationCodeSignupConatainer = (props) => (
        <HomeCarouselAuthLayout {...props} hasAccessToAStudioGym={false}>
            <InvitationCodeSignup {...props} />
        </HomeCarouselAuthLayout>
)

const WelcomeContainer = (props) => {
    return (
        <HomeCarouselAuthLayout hasAccessToAStudioGym={false} {...props} hideScroll>
            <WelcomeMobileWeb {...props} />
        </HomeCarouselAuthLayout>
    )
}

const CreatePreAccountContainer = (props) => (
  <HomeCarouselAuthLayout {...props} hasAccessToAStudioGym={true}>
      <CreatePreAccount {...props} />
  </HomeCarouselAuthLayout>
)

const PreAccountSetPasswordContainer = (props) => (
  <HomeCarouselAuthLayout {...props} hasAccessToAStudioGym={true}>
      <PreAccountSetPasswordScreen {...props} />
  </HomeCarouselAuthLayout>
)

const CaptureEmailContainer = (props) => (
  <HomeCarouselAuthLayout {...props} hasAccessToAStudioGym={true}>
      <CaptureEmailScreen {...props} />
  </HomeCarouselAuthLayout>
)

const PreAuthPaymentContainer = (props) => (
  <HomeCarouselAuthLayout {...props} hasAccessToAStudioGym={true}>
    <PreLoadedPlanDetails {...props} />
  </HomeCarouselAuthLayout>
)

const AuthNavigator = createSwitchNavigator({
    Login: {
        screen: LoginContainer,
        path: 'login',
    },
    SignUp: {
        screen: SignupContainer,
        path: 'signup',
    },
    ForgotPassword: {
        screen: ForgotPasswordContainer,
        path: 'forgot',
    },
    SocialAuthLoading: {
        screen: SocialAuthLoading,
        path: 'socialAuthLoading',
    },
    GuardianConsent: {
        screen: GuardianConsentScreenContainer,
        path: 'guardian-consent',
    },
    PreLoadedPlanDetails: {
        screen: PreLoadedPlanDetailsContainer,
        path: 'preloaded-plan-details',
    },
    ExternalPlanSelection: {
        screen: ExternalPlanSelectionContainer,
        path: 'plan-selection',
    },
    CreateEliteAccount: {
        screen: CreateEliteAccountContainer,
        path: 'create-elite-account',
    },
    InviteToWorkout: {
        screen: InviteToWorkoutContainer,
        path: 'invite-signup',
    },
    InvitationCodeSignup: {
        screen: InvitationCodeSignupConatainer,
        path: 'family-plan-invitation'
    },
    CreatePreAccount: {
        screen: CreatePreAccountContainer,
        path: 'create-pre-account',
    },
    HomeInstallAppScreen: {
        screen: HomeInstallAppContainer,
        path: 'install-app',
    },
    CaptureEmail: {
        screen: CaptureEmailContainer,
        path: 'capture-email',
    },
    PreAccountSetPassword: {
        screen: PreAccountSetPasswordContainer,
        path: 'pre-account-set-password',
    },
    Welcome: {
        screen: LoginContainer,
        path: 'welcome',
    },
    PreAuthPayment: {
        screen: PreAuthPaymentContainer,
        path: 'payment',
    },
}, {
    initialRouteName: 'Login'
});

export default AuthNavigator;
